import React, { useState, useEffect } from 'react';

const PercentageCalculator = ({ percentage }) => {
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (percentage > 0) {
      setValue1(percentage);
    } else {
      setValue1('Valeur');
    }
  }, [percentage]);

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('Veuillez entrer les deux valeurs correctement');
      setResult('');
      setExplanation('');
      return;
    }
    const pct = parseFloat(value1);
    const ofValue = parseFloat(value2);
    const calculatedResult = (pct / 100) * ofValue;
    setResult(calculatedResult.toFixed(2));
    setExplanation(
      `${value1}% de ${value2} = (${value1}/100) * ${value2} = ${pct / 100} * ${ofValue} = ${calculatedResult.toFixed(2)}`
    );
    setError('');
  };

  return (
    <div>
      <style>{`
        .calc-wrapper {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }
        .calc-btn {
          font-size: 20px;
          white-space: nowrap;
        }
        @media (max-width: 767px) {
          .calc-btn {
            width: 100%;
            margin-top: 6px;
            text-align: center;
          }
        }
      `}</style>

      <div className="calc-wrapper">
        <input
          type="number"
          placeholder={value1}
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <span>% de</span>
        <input
          type="number"
          placeholder="Valeur"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control"
          style={{ flex: 1, minWidth: '80px' }}
        />
        <button
          className="btn btn-success"
          onClick={handleCalculate}
        >
          Calculer
        </button>
      </div>

      <br />
      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-white">Erreur: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  Résultat: {value1}% de {value2} = {result}
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-black">
                    Étapes de la solution: <br />
                    {explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>

    </div>
  );
};

export default PercentageCalculator;
